import {Component, Input, OnInit} from '@angular/core';

import {BehaviorSubject} from 'rxjs';

import {BaseControl} from '../../classes';
import {FormArrayComponent} from '../form-array';

@Component({
    selector: 'app-form-array-grouped',
    templateUrl: './form-array-grouped.component.html',
    styleUrls: ['./form-array-grouped.component.scss']
})
export class FormArrayGroupedComponent<FormsControlType = string | number> extends FormArrayComponent implements OnInit {
    @Input() public formArrayObservable: BehaviorSubject<Array<BaseControl<FormsControlType>[]>>;

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (!this.formArrayObservable) {
            this.formArrayObservable = new BehaviorSubject([]);
        }
    }
}
